import { Injectable } from '@angular/core';
import { NewShopItem, ShoppingListItemModel, ShoppingListModel } from '@libs/shop/models';
import { ConnectionParams } from '@libs/shared/models';
import { ConnectorService } from '@libs/shared/services';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ShoppingListsRepositoryService {
  public constructor(private readonly connector: ConnectorService) {}

  public getAll(): Observable<ShoppingListModel[]> {
    return this.connector.connect('shop', 'shoppingLists');
  }

  public addNewShoppingList(name: string): Observable<ShoppingListModel> {
    const payload: NewShopItem<ShoppingListModel> = {
      type: 'shopping-list',
      name,
    };

    return this.connector.connect('shop', 'shoppingListsCreate', { payload });
  }

  public addProductToShoppingList(listId: string, sku: string, quantity: number): Observable<ShoppingListItemModel> {
    const payload: NewShopItem<ShoppingListItemModel> = {
      type: 'shopping-list-items',
      sku,
      quantity,
    };

    const params: ConnectionParams = {
      payload,
      pathParams: { listId },
    };

    return this.connector.connect('shop', 'shoppingListsAddProduct', params);
  }
}
